export default [
  {
    key: 'actions',
    sortable: false,
    visible: true,
    tdClass: (value, index, item) => {
      if (!item.category) {
        return ['current-month', 'text-white']
      }
    }
  },
  {
    key: 'date',
    sortable: true,
    visible: true,
    tdClass: (value, index, item) => {
      if (!item.category) {
        return ['current-month', 'text-white']
      }
    }
  },
  {
    key: 'confirmed',
    label: 'Profit & Loss',
    sortable: true,
    visible: true,
    tdClass: (value, index, item) => {
      if (!item.category) {
        return ['current-month', 'text-white']
      }
    }
  },
  {
    key: 'type',
    sortable: true,
    visible: true,
    tdClass: (value, index, item) => {
      if (!item.category) {
        return ['current-month', 'text-white']
      }
    }
  },
  {
    key: 'amount',
    sortable: true,
    visible: true,
    tdClass: (value, index, item) => {
      if (!item.category) {
        return ['current-month', 'text-white']
      }
    }
  },
  {
    key: 'account_used',
    label: 'account',
    sortable: true,
    visible: true,
    tdClass: (value, index, item) => {
      if (!item.category) {
        return ['current-month', 'text-white']
      }
    }
  },
  {
    key: 'description',
    visible: true,
    tdClass: (value, index, item) => {
      if (!item.category) {
        return ['current-month', 'text-white']
      }
    }
  },
  {
    key: 'category',
    sortable: false,
    visible: true,
    tdClass: (value, index, item) => {
      if (!item.category) {
        return ['current-month', 'text-white']
      }
    }
  },
  {
    key: 'primary_source',
    label: 'Lead Source',
    sortable: true,
    visible: true,
    tdClass: (value, index, item) => {
      if (!item.category) {
        return ['current-month', 'text-white']
      }
    }
  },
  {
    key: 'recurring',
    sortable: true,
    visible: true,
    tdClass: (value, index, item) => {
      if (!item.category) {
        return ['current-month', 'text-white']
      }
    }
  }
];